// extracted by mini-css-extract-plugin
export var buttons = "styles-module--buttons--a4e2e";
export var container = "styles-module--container--5cbcf";
export var content = "styles-module--content--9955b";
export var media = "styles-module--media--50cfd";
export var text = "styles-module--text--b7171";